import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=0cc68e0f&"
import script from "./LeftPanel.vue?vue&type=script&lang=js&"
export * from "./LeftPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc68e0f')) {
      api.createRecord('0cc68e0f', component.options)
    } else {
      api.reload('0cc68e0f', component.options)
    }
    module.hot.accept("./LeftPanel.vue?vue&type=template&id=0cc68e0f&", function () {
      api.rerender('0cc68e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffCalendar/LeftPanel.vue"
export default component.exports